module.exports = __webpack_public_path__ + "img/bj_zanwu_2.06f8dd04.png";